export default [
  {
    width: 17,
    header: {
      type: 'text',
      caption: 'baseCurrency',
    },
    cell: {
      type: 'text',
      value: (e) => e.baseCurrency,
    },
  },
  {
    width: 17,
    header: {
      type: 'text',
      caption: 'quoteCurrency',
    },
    cell: {
      type: 'text',
      value: (e) => e.quoteCurrency,
    },
  },
  {
    width: 17,
    header: {
      type: 'text',
      caption: 'rate',
    },
    cell: {
      type: 'slot',
      name: 'rate',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'coefficient',
    },
    cell: {
      type: 'slot',
      name: 'coefficient',
    },
  },
  {
    width: 15,
    header: {
      type: 'text',
      caption: '',
    },
    cell: {
      type: 'slot',
      name: 'controls',
    },
  },
];
